// extracted by mini-css-extract-plugin
var _1 = "bwNYf";
var _2 = "IZBSy";
var _3 = "EUzVl";
export { _1 as "base", _2 as "matchPrefix", _3 as "suggestion" }
